import {pieChartSvg as Icon__small__pieChartSvg} from '../Icon__small/Icon__small--pieChart.js';

export var pieChart = {
  name: 'pieChart',
  category: 'icon',
  colorable: true,
  svg: Icon__small__pieChartSvg,
};
